import { useContext, useRef, useState } from "react";
import { StyledSelect } from "./styles";
import { UserContext } from "../../providers/UserContext";

export const Select = ({
    id,
    name,
    placeholder,
    value,
    setValue,
    attribute,
    options,
    register,
}: any) => {
    const { user } = useContext(UserContext)

    const [transform, setTransform] = useState(false),
        selectedOption = useRef<any>(""),
        bottomPos = useRef(0);

    //Get option when click in select options
    const selectOption = (event: any, data: any) => {
        selectedOption.current = data;
        setValue(attribute, selectedOption.current.value, { shouldValidate: true });
    };

    return (
        <StyledSelect
            transform={transform}
            bottompos={bottomPos.current}
            togglelist={transform}
        >
            <div
                className="selectContainer"
                onClick={(event: any) => {
                    setTransform(transform === false);
                    bottomPos.current =
                        window.innerHeight - event.target.getBoundingClientRect().bottom;
                }}
            >
                <input
                    type="text"
                    id={id}
                    name={name}
                    value={!selectedOption.current ? value : selectedOption.current.option}
                    defaultValue={user && user.icon}
                    placeholder={placeholder}
                    {...register(name)}
                    readOnly
                />
                {transform && (
                    <ul>
                        {options.map((elm: any, i: number) => {
                            if (elm) {
                                return (
                                    <li
                                        key={i}
                                        onClick={(event) => {
                                            selectOption(event, { value: elm.value, option: `${elm.name}` });
                                        }}
                                    >
                                        <img src={elm.value} alt={`option${i}`} />
                                    </li>
                                );
                            }
                        })}
                    </ul>
                )}
            </div>
            {/* <span></span> */}
        </StyledSelect>
    );
};